// extracted by mini-css-extract-plugin
module.exports = {"screen":"Reports_screen__9bwX4"};